import React, { useContext, useEffect, useState } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import './introduction.scss';
import { KibDisplayObserver } from '@chewy/kib-display-react';
import { DATAFILE_VERSIONS } from '@optimizely/optimizely-sdk/lib/utils/enums';
import AnalyticsContext from '../../context/AnalyticsContext';
import {
  ANALYTICS_ACTION_IMPRESSION,
  ANALYTICS_LABEL_SUFFIX_HEADER,
} from '../../AnalyticsProvider';
import { imgPath } from './constants';
import { getMainIntro } from './content/contentHelper';

const transBaseKey = 'puppyGuide.introduction';

const Introduction = ({ t }: { t: TFunction<string> }) => {
  const analytics = useContext(AnalyticsContext);
  const [impressionRecorded, setImpressionRecorded] = useState<Boolean>(false);
  return (
    <KibDisplayObserver
      enter={() => {
        if (!impressionRecorded) {
          analytics.trackStarterGuide(
            ANALYTICS_ACTION_IMPRESSION,
            `${t(`${transBaseKey}.title`)}${ANALYTICS_LABEL_SUFFIX_HEADER}`,
          );
          setImpressionRecorded(true);
        }
      }}
    >
      <div className="starter-guide-introduction">
        <div className="starter-guide-introduction__sections starter-guide-introduction__sections--img">
          <img
            src={`${imgPath}/authorNelson.jpg`}
            alt=""
            className="starter-guide-introduction__img"
          />
        </div>
        <div className="starter-guide-introduction__sections starter-guide-introduction__content">
          <h2 className="starter-guide-introduction__title">{t(`${transBaseKey}.title`)}</h2>
          <div className="starter-guide-introduction__text starter-guide-introduction__text--content">
            {getMainIntro()}
          </div>
          <div className="starter-guide-introduction__text">
            <div>{t('puppyGuide.author.introBy')}:</div>
            <div className="starter-guide-introduction__author">{t('puppyGuide.author.name')}</div>
          </div>
        </div>
      </div>
    </KibDisplayObserver>
  );
};

export default withTranslation()(Introduction);
